<template>
  <div>
    <reports-table
      tableName="Reporte simple"
      :isDetailedReport="false"
      :permission="{
        downloadPermission: permissions.DOWNLOAD_SIMPLE_REPORT,
      }"
    ></reports-table>
  </div>
</template>

<script>
import ReportsTable from "../../../../components/Administration/ReportsTable.vue";
import { permissions } from "../../../../enum/applicationPermissions";
export default {
  components: {
    ReportsTable,
  },
  data() {
    return {
      permissions: permissions,
    };
  },
};
</script>

<style scoped></style>
